import React, { Component } from "react";
import { Fade, Slide } from "react-reveal";
import {ImInstagram} from 'react-icons/im';

import { Helmet } from "react-helmet";

class Contact extends Component {
  render() {
    if (!this.props.data) return null;


    return (
      <section id="contact">
        <Helmet>

        <meta 
          name='description'
          content='Please contact us via Email: steven@altnetix.com or phone: 229-288-9338'
          />
        </Helmet>
        <Fade bottom duration={1000}>
          <div className="row section-head">
            <div className="two columns header-col">
              <h1>
                <span>Get In Touch.</span>
              </h1>
            </div>

            <div className="ten columns">
              <p className="lead">Please enter your infromation below and we will contact you soon!</p>
            </div>
          </div>
        </Fade>

        <div className="row">
          <Slide left duration={1000}>
            <div className="eight columns">
              <form action="" method="post" id="contactForm" name="contactForm">
                <fieldset>
                  <div>
                    <label htmlFor="contactName">
                      Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      defaultValue=""
                      size="35"
                      id="contactName"
                      name="contactName"
                      onChange={this.handleChange}
                    />
                  </div>

                  <div>
                    <label htmlFor="contactEmail">
                      Email <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      defaultValue=""
                      size="35"
                      id="contactEmail"
                      name="contactEmail"
                      onChange={this.handleChange}
                    />
                  </div>

                  <div>
                    <label htmlFor="contactSubject">Subject</label>
                    <input
                      type="text"
                      defaultValue=""
                      size="35"
                      id="contactSubject"
                      name="contactSubject"
                      onChange={this.handleChange}
                    />
                  </div>

                  <div>
                    <label htmlFor="contactMessage">
                      Message <span className="required">*</span>
                    </label>
                    <textarea
                      cols="50"
                      rows="15"
                      id="contactMessage"
                      name="contactMessage"
                    ></textarea>
                  </div>

                  <div>
                    <button className="submit">Submit</button>
                    <span id="image-loader">
                      <img alt="" src="images/loader.gif" />
                    </span>
                  </div>
                </fieldset>
              </form>

              <div id="message-warning"> Error boy</div>
              <div id="message-success">
                <i className="fa fa-check"></i>Your message was sent, thank you!
                <br />
              </div>
            </div>
          </Slide>

          <Slide right duration={1000}>
            <aside className="four columns footer-widgets">
              <div className="widget widget_contact">
                <h4>Phone</h4>
                <p className="address">
                  Altnetix LLC
                  <br />
                  Marietta, GA 30062
                  <br />
                  <span>229 288 9338</span>
                </p>
              </div>

              <div className="widget widget_tweets">
                <h4 className="widget-title">Latest Posts</h4>
                <ul id="instagram">
                  <li>
                    <a href='https://www.instagram.com/altnetix/'>
                      <ImInstagram style={{color: '#fe5555', width:'30px', height:'30px'}}/>
                    </a>
                  </li>
                </ul>
              </div>
            </aside>
          </Slide>
        </div>
        
      </section>
    );
  }
}

export default Contact;
